/**
 * 
 * @param {string} name 
 * @returns 
 */

import key from './key'

const url = `app/${key}`

export const LOAD_PENDING_PRODUCT_WISE_COUNT = `${url}/LOAD_PENDING_PRODUCT_WISE_COUNT`
export const LOAD_PENDING_PRODUCT_WISE_COUNT_SUCCESS = `${url}/LOAD_PENDING_PRODUCT_WISE_COUNT_SUCCESS`
export const LOAD_PENDING_PRODUCT_WISE_COUNT_ERROR = `${url}/LOAD_PENDING_PRODUCT_WISE_COUNT_ERROR`

export const LOAD_RECORDS_META_DATA = `${url}/LOAD_RECORDS_META_DATA`
export const LOAD_RECORDS_META_DATA_SUCCESS = `${url}/LOAD_RECORDS_META_DATA_SUCCESS`
export const LOAD_RECORDS_META_DATA_ERROR = `${url}/LOAD_RECORDS_META_DATA_ERROR`
export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`

const constants = {
  LOAD_PENDING_PRODUCT_WISE_COUNT,
  LOAD_PENDING_PRODUCT_WISE_COUNT_SUCCESS,
  LOAD_PENDING_PRODUCT_WISE_COUNT_ERROR,

  LOAD_RECORDS_VALID_CACHE,

  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,

}

export default constants
